import {ChangeDetectionStrategy, Component, ElementRef, ViewChild} from '@angular/core';
import {ViewSelectSnapshot} from '@ngxs-labs/select-snapshot';
import {User} from '../../../../models/api/user.model';
import {WhiteLabel} from '../../../../models/api/white-label.model';
import {FileService} from '../../../../services/file.service';
import {AuthState} from '../../../../state/auth/auth.state';
import {AppState} from '../../../../state/app/app.state';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavbarComponent {
    @ViewSelectSnapshot(AuthState.currentUser) currentUser: User;
    @ViewSelectSnapshot(AppState.layoutSmall)
    layoutSmall: boolean;
    isSidebarOpen = false;
    @ViewChild('trigger', {read: ElementRef}) triggerElement: ElementRef;

    constructor(private fileService: FileService) {}

    getPartnerLogoUrl(whiteLabel: WhiteLabel) {
        const url = this.fileService.getFileUrl(whiteLabel?.partnerLogo?.hash);
        return url;
    }
}
